import { CAMPAIGN_PERMISSIONS } from './campaign';
import { COHORT_PERMISSIONS } from './cohort';
import { CUSTOMER_PERMISSIONS } from './customer';
import { DEFAULT_STORE_PERMISSIONS } from './default-store';
import { DELIVERY_PERMISSIONS } from './delivery';
import { DOMAIN_MANAGEMENT_PERMISSIONS } from './domain-management';
import { FRANCHISE_MANAGEMENT_PERMISSIONS } from './franchise-management';
import { FRANCHISE_REPORTS_PERMISSIONS } from './franchise-reports';
import { GIFT_CARDS_PERMISSIONS } from './gift-cards';
import { LOYALTY_PERMISSIONS } from './loyalty';
import { MERCHANT_PERMISSIONS } from './merchant';
import { MERCHANT_MENU_MANAGEMENT_PERMISSIONS } from './merchant-menu-management';
import { MERCHANT_ORDER_PERMISSIONS } from './merchant-order';
import { MULTI_BRANDS_MANAGEMENT_PERMISSIONS } from './multi-brands-management';
import { PROMOTION_PERMISSIONS } from './promotion';
import { ROLE_PERMISSION } from './role-permission';
import { STORE_PERMISSIONS } from './store';
import { STORE_DINING_OPTIONS_PERMISSIONS } from './store-dining-options';
import { STORE_MENU_MANAGEMENT_PERMISSIONS } from './store-menu-management';
import { STORE_NOTIFICATIONS_PERMISSIONS } from './store-notifications';
import { STORE_ORDER_PERMISSIONS } from './store-order';
import { STORE_ORDER_CONFIG_PERMISSIONS } from './store-order-config';
import { STORE_PAYMENT_PERMISSIONS } from './store-payment';
import { STORE_REPORTS_PERMISSIONS } from './store-reports';
import { STORE_SERVICE_CHARGES_PERMISSIONS } from './store-service-charges';
import { USER_V2_PERMISSIONS } from './user-v2';
import { VENDOR_PERMISSIONS } from './vendor';
import { NOTIFIER_PERMISSIONS } from './notifier';
import { STORE_PROMOTION_PERMISSIONS } from './store-promotion';
import { WEBSTORE_PERMISSIONS } from './webstore';
import { MERCHANT_ROYALTY_FEE_PERMISSIONS } from './merchant-royalty-fee';
import { MERCHANT_INVOICE } from './merchant-invoice';
export const PermissionsV2 = Object.freeze({
    CAMPAIGN: CAMPAIGN_PERMISSIONS,
    COHORT: COHORT_PERMISSIONS,
    CUSTOMER: CUSTOMER_PERMISSIONS,
    DEFAULT_STORE: DEFAULT_STORE_PERMISSIONS,
    DELIVERY: DELIVERY_PERMISSIONS,
    DOMAIN_MANAGEMENT: DOMAIN_MANAGEMENT_PERMISSIONS,
    FRANCHISE_MANAGEMENT: FRANCHISE_MANAGEMENT_PERMISSIONS,
    FRANCHISE_REPORTS: FRANCHISE_REPORTS_PERMISSIONS,
    GIFT_CARDS: GIFT_CARDS_PERMISSIONS,
    LOYALTY: LOYALTY_PERMISSIONS,
    MERCHANT: MERCHANT_PERMISSIONS,
    MERCHANT_MENU_MANAGEMENT: MERCHANT_MENU_MANAGEMENT_PERMISSIONS,
    MERCHANT_ORDER: MERCHANT_ORDER_PERMISSIONS,
    MERCHANT_ROYALTY_FEE: MERCHANT_ROYALTY_FEE_PERMISSIONS,
    MERCHANT_INVOICE: MERCHANT_INVOICE,
    MULTI_BRANDS_MANAGEMENT: MULTI_BRANDS_MANAGEMENT_PERMISSIONS,
    PROMOTION: PROMOTION_PERMISSIONS,
    ROLE_PERMISSION: ROLE_PERMISSION,
    STORE: STORE_PERMISSIONS,
    STORE_DINING_OPTIONS: STORE_DINING_OPTIONS_PERMISSIONS,
    STORE_MENU_MANAGEMENT: STORE_MENU_MANAGEMENT_PERMISSIONS,
    STORE_NOTIFICATIONS: STORE_NOTIFICATIONS_PERMISSIONS,
    STORE_ORDER: STORE_ORDER_PERMISSIONS,
    STORE_ORDER_CONFIG: STORE_ORDER_CONFIG_PERMISSIONS,
    STORE_PAYMENT: STORE_PAYMENT_PERMISSIONS,
    STORE_PROMOTION: STORE_PROMOTION_PERMISSIONS,
    STORE_REPORTS: STORE_REPORTS_PERMISSIONS,
    STORE_SERVICE_CHARGES: STORE_SERVICE_CHARGES_PERMISSIONS,
    USER_V2: USER_V2_PERMISSIONS,
    VENDOR: VENDOR_PERMISSIONS,
    NOTIFIER: NOTIFIER_PERMISSIONS,
    WEBSTORE: WEBSTORE_PERMISSIONS,
});
export const AllPermissionsV2 = Object.freeze(Object.values(PermissionsV2)
    .map((entityPermissions) => Object.values(entityPermissions))
    .reduce((acc, value) => acc.concat(value), []));
//# sourceMappingURL=index.js.map